import { render, staticRenderFns } from "./ModifierGroupEdit.vue?vue&type=template&id=2e20ac14&scoped=true"
import script from "./ModifierGroupEdit.vue?vue&type=script&lang=js"
export * from "./ModifierGroupEdit.vue?vue&type=script&lang=js"
import style0 from "./ModifierGroupEdit.vue?vue&type=style&index=0&id=2e20ac14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e20ac14",
  null
  
)

export default component.exports